import { makeStyles } from '@material-ui/core/styles';
import { GRADIENT_VARIANT_TO_GRADIENT } from './config';
import { InputGradientBorderStylesArgs } from './types';

export const useGradientBorderStyles = ({
  gradient,
  backgroundColor = '#fff'
}: InputGradientBorderStylesArgs) => {
  const gradientValue = GRADIENT_VARIANT_TO_GRADIENT[gradient];

  let background = `linear-gradient(${backgroundColor}, ${backgroundColor})`;

  if (backgroundColor.includes('linear-gradient')) {
    background = backgroundColor;
  }

  return makeStyles({
    inputBorderGradientClass: {
      '& .MuiInputBase-root': {
        background: `${background} padding-box, ${gradientValue} border-box`,
        border: '1px solid transparent',
        '&.Mui-error': {
          background,
          borderColor: '#FF0000'
        },
        '&.Mui-disabled': {
          background,
          borderColor: 'rgba(0, 0, 0, 0.26)'
        }
      },
      '& fieldset': {
        border: 'none'
      }
    },
    buttonBorderGradientClass: {
      '&.MuiButtonBase-root': {
        background: `${background} padding-box, ${gradientValue} border-box`,
        border: '1px solid transparent'
      }
    },
    boxBorderGradientClass: {
      '&.MuiBox-root': {
        background: `${background} padding-box, ${gradientValue} border-box`,
        border: '1px solid transparent'
      }
    }
  })();
};
